/**
 * B19 themes API client (public). Lists active custom themes + the globally
 * forced theme (admin CF-2113). Used by ThemeController + the Settings selector.
 */

interface Envelope<T> {
  success: boolean;
  data: T | null;
}

export interface CustomTheme {
  id: number;
  name: string;
  palette: Record<string, unknown>;
  typography: Record<string, unknown> | null;
}

export interface ThemesResponse {
  themes: CustomTheme[];
  global: CustomTheme | null;
}

export async function getThemes(): Promise<ThemesResponse> {
  try {
    const res = await fetch('/api/v1/themes', { method: 'GET', credentials: 'include' });
    const env = (await res.json()) as Envelope<ThemesResponse>;
    if (res.ok && env.success && env.data) {
      return env.data;
    }
  } catch {
    /* fail-soft: theming falls back to built-in variants */
  }
  return { themes: [], global: null };
}
